<template>
  <div :class="{ 'sidebar-position-index': true }">
    <SidebarTopRightOrientation>
      <div class="sidebar-top-right-orientation__right">
        <button
          @click="closeSidebarPositionIndex"
          class="sidebar-top-right-orientation__button"
        >
          <div class="sidebar-top-right-orientation__button__text">Sluit</div>
          <svg class="sidebar-top-right-orientation__button__icon" svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-45 12 12)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(45 12 12)" d="M11 4h2v16h-2z"/></g></svg>
        </button>
      </div>
    </SidebarTopRightOrientation>

    <div class="sidebar-position-index__titlebar">
      <div class="sidebar-position-index__left">
        <div class="sidebar-position-index__title">Locaties beheren</div>
      </div>
      <div class="sidebar-position-index__right">
        <svg class="sidebar-position-index__plus-icon" svg-inline="" @click="openSidebarPositionNew" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(90 12 12)" d="M11 4h2v16h-2z"/></g></svg>
      </div>
    </div>

    <div
      class="sidebar-position-index__titlebar-secondary"
      @click="openSidebarCategoriesIndex"
    >
      <svg class="sidebar-position-index__filter-icon" svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" fill="#101010" mask="url(#b)"/></g></svg>
      <div class="sidebar-position-index__title-secondary">
        Beheer categorieën van meldingen
      </div>
    </div>

    <div class="sidebar-position-index__bottom">
      <div class="sidebar-position-index__vertical-cards">
        <div
          v-for="position in loadedPositions.data"
          :key="position.id"
          class="position-card"
          @click="setActivePosition(position)"
        >
          <div class="position-card__maps">
            <img
              :src="
                `https://maps.googleapis.com/maps/api/staticmap?center=${
                  position.latitude
                },${
                  position.longitude
                }&zoom=19&size=544x306&markers=anchor:center%7Cicon:https://web.omgevingsalert.nl/ic_location@2x.png%7Clabel:S%7C${
                  position.latitude
                },${
                  position.longitude
                }&key=AIzaSyCACrRZAKwfGCbUx9tX2cxWSyRe2LK4fwg`
              "
              alt=""
            />
          </div>
          <div class="position-card__bottom">
            <div class="position-card__radius-text">
              Meldingen binnen {{ position.radius }} meter van
            </div>
            <div
              class="position-card__address-text"
              :style="{
                color: position.gemeente.app_asset
                  ? position.gemeente.app_asset.color_primary
                  : null
              }"
            >
              {{ position.address }}, {{ position.gemeente.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <portal to="page-shadow">
      <PageShadow />
    </portal>
  </div>
</template>

<script>
import PageShadow from "@/components/PageShadow.vue";
import SidebarTopRightOrientation from "@/components/SidebarTopRightOrientation.vue";

export default {
  components: {
    SidebarTopRightOrientation,
    PageShadow
  },
  data() {
    return {};
  },
  computed: {
    loadedPositions() {
      return this.$store.state.data.loadedPositions;
    }
  },
  methods: {
    closeSidebarPositionIndex() {
      this.$store.commit("closeSidebarPositionIndex");
    },
    setActivePosition(position) {
      this.$store.commit("setActivePosition", position);
      this.$store.commit("openSidebarPositionEdit");
      this.$store.commit("closeSidebarPositionIndex");
    },
    openSidebarPositionNew() {
      this.$store.commit("openSidebarMunicipalitiesIndex");
      this.$store.commit("closeSidebarPositionIndex");
    },
    openSidebarCategoriesIndex() {
      this.$store.commit("openSidebarCategoriesIndex");
      this.$store.commit("closeSidebarPositionIndex");
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar-position-index {
  position: fixed;
  width: 100%;
  max-width: 414px;
  background: $color-gray-2;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 3000;

  &__titlebar {
    display: flex;
    align-items: center;
    background: #fff;
    border-bottom: 1px solid $color-gray-1;
    padding: 0 $spacing-3;
    height: 64px;
  }

  &__left {
  }

  &__title {
    @extend %text-title-2;
  }

  &__right {
    margin-left: auto;
  }

  &__plus-icon {
    cursor: pointer;
  }

  &__filter-icon {
    margin-right: $spacing-2;
  }

  &__titlebar-secondary {
    cursor: pointer;
    display: flex;
    align-items: center;
    border-bottom: 1px solid $color-gray-1;
    padding: 0 $spacing-3;
    background: #fff;
    height: 52px;
  }

  &__title-secondary {
    @extend %text-small;
  }

  &__vertical-cards {
    display: flex;
    flex-direction: column;
    padding-top: $spacing-3;
  }

  &__bottom {
    flex: 1;
    overflow-y: auto;
  }
}

.position-card {
  cursor: pointer;
  margin-bottom: $spacing-3;
  margin-left: $spacing-3;
  margin-right: $spacing-3;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  box-shadow: $shadow-1;

  &__bottom {
    padding: $spacing-3;
    border-radius: 0 0 10px 10px;
    background: #fff;
  }
  &__radius-text {
    @extend %text-small;
  }
  &__address-text {
    @extend %text-title-2;
  }
}

@media (min-width: 768px) {
  .sidebar-position-index {
    &__titlebar {
      padding: 0 $spacing-4;
    }
    &__titlebar-secondary {
      padding: 0 $spacing-4;
    }
    &__vertical-cards {
      padding-top: $spacing-4;
    }
  }
  .position-card {
    margin-bottom: $spacing-4;
    margin-left: $spacing-4;
    margin-right: $spacing-4;

    &__bottom {
      padding: $spacing-4;
    }
  }
}
</style>
